import { awards, members, professor, publications, researchAreas } from "../data";
import { ArrowLink, ExternalLink, SectionHeader } from "../components/Shell";
import { PublicationRow } from "../components/Records";
import { ResearchExplorer, ResearchFigure } from "../components/ResearchView";

const featuredArea = researchAreas.find((area) => area.figure === "weather") || researchAreas[0];
const featuredPublication =
  publications.find((publication) => publication.id === featuredArea.publicationId) ||
  publications[0];
const recentPublications = publications.slice(0, 5);

export default function HomePage() {
  return (
    <>
      <section className="home-masthead shell" aria-labelledby="home-title">
        <div className="masthead-copy">
          <p className="section-label">Yonsei School of Business</p>
          <h1 id="home-title">
            <span>최정혜 교수</span>
            <span>연구실</span>
          </h1>
          <p className="masthead-meta">
            Marketing · Professor Jeonghye Choi
            <br />
            Underwood Distinguished Professor
          </p>
          <p className="masthead-topics" aria-label="연구 분야">
            <span>디지털 마케팅</span>
            <span>소비자 행동</span>
            <span>플랫폼 데이터</span>
          </p>
        </div>
        <article className="masthead-work">
          <div className="masthead-work-head">
            <span>Selected work</span>
            <span>{featuredPublication.year}</span>
          </div>
          <div className="masthead-figure">
            <ResearchFigure area={featuredArea} compact />
          </div>
          <div className="masthead-paper">
            <h2 lang="en">{featuredPublication.title}</h2>
            <p>{featuredPublication.venue}</p>
          </div>
        </article>
      </section>

      <aside className="latest-strip" aria-label="최근 기록">
        <div className="latest-inner shell">
          <span className="latest-label">Latest</span>
          <span className="latest-title" lang="en">
            {publications[0].title}
          </span>
          <span className="latest-meta">{publications[0].venue}</span>
        </div>
      </aside>

      <section className="home-section shell" aria-labelledby="selected-research">
        <SectionHeader
          label="Research"
          title="선정 연구"
          action={<ArrowLink to="/research">연구 전체 보기</ArrowLink>}
        />
        <h2 id="selected-research" className="sr-only">
          선정 연구
        </h2>
        <ResearchExplorer />
      </section>

      <section className="home-section is-white" aria-labelledby="professor-heading">
        <div className="shell">
          <SectionHeader
            label="Professor"
            title="최정혜"
            action={<ArrowLink to="/about">교수 소개</ArrowLink>}
          />
          <div className="professor-grid">
            <figure className="professor-photo">
              <img
                src="/media/choi-jeonghye.jpg"
                alt="최정혜 연세대학교 경영대학 교수"
                width="472"
                height="591"
              />
            </figure>
            <div className="professor-bio">
              <h2 className="professor-name" id="professor-heading">
                {professor.title}
                <span>{professor.nameEn}</span>
              </h2>
              <p>{professor.introduction}</p>
              <div className="professor-links">
                <ExternalLink href={professor.officialProfileUrl}>공식 프로필</ExternalLink>
                <a className="external-link" href={`mailto:${professor.email}`}>
                  Email
                </a>
              </div>
            </div>
            <div className="professor-record" aria-label="주요 경력과 수상">
              {[
                { year: "2021", title: "언더우드 특훈교수" },
                { year: "2015", title: "MSI Young Scholar" },
                { year: "2013", title: "Robert D. Buzzell MSI Best Paper Award" },
                awards.find((award) => award.year === "2021")
              ]
                .filter(Boolean)
                .map((record, index) => (
                  <div className="record-row" key={`${record!.year}-${index}`}>
                    <span className="record-year">{record!.year}</span>
                    <div>
                      <p className="record-title">{record!.title}</p>
                      {"detail" in record! && record!.detail ? (
                        <p className="record-detail">{record!.detail}</p>
                      ) : null}
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <p className="photo-credit">
            프로필 사진: 연세대학교 경영대학 공식 교수진 페이지 · 최종 공개 전 사용 승인 확인
          </p>
        </div>
      </section>

      <section className="home-section shell" aria-labelledby="recent-publications">
        <SectionHeader
          label="Publications"
          title="최근 출판 기록"
          action={<ArrowLink to="/publications">83건 전체 보기</ArrowLink>}
        />
        <h2 id="recent-publications" className="sr-only">
          최근 출판 기록
        </h2>
        <div className="publication-list">
          {recentPublications.map((publication) => (
            <PublicationRow key={publication.id} publication={publication} />
          ))}
        </div>
      </section>

      <section className="home-section is-white">
        <div className="members-contact shell">
          <div>
            <SectionHeader
              label="People"
              title="현재 구성원"
              action={<ArrowLink to="/people">구성원 보기</ArrowLink>}
            />
            <div className="member-names">
              {members.map((member) => (
                <p className="member-name" key={member.name}>
                  {member.name}
                </p>
              ))}
            </div>
          </div>
          <div>
            <SectionHeader label="Contact" title="연구실 위치" />
            <figure className="campus-contact">
              <img
                src="/media/yonsei-baekyang.jpg"
                alt="연세대학교 백양로"
                width="1920"
                height="2560"
                loading="lazy"
              />
              <figcaption className="campus-contact-copy">
                <p>
                  연세대학교 경영관 537호
                  <br />
                  서울특별시 서대문구 연세로 50
                </p>
                <ArrowLink to="/contact">연락처와 오시는 길</ArrowLink>
              </figcaption>
            </figure>
            <p className="photo-credit">
              사진: Striker9498 · Wikimedia Commons · CC BY-SA 4.0
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
